"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryStore = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const lincd_storage_1 = require("../ontologies/lincd-storage");
const QuadSet_1 = require("lincd/lib/collections/QuadSet");
const SHACL_1 = require("lincd/lib/shapes/SHACL");
const QuadArray_1 = require("lincd/lib/collections/QuadArray");
let InMemoryStore = class InMemoryStore extends Shape_1.Shape {
    constructor(n) {
        super(n);
        // this.init();
    }
    init() {
        if (!this.initPromise) {
            this.initPromise = this.loadContents();
        }
        return this.initPromise;
    }
    loadContents() {
        //by default an in-memory store starts empty - it has no permanent storage
        //overwrite this method to change that
        this.contents = new QuadSet_1.QuadSet();
        return Promise.resolve(this.contents);
    }
    update(toAdd, toRemove) {
        return this.init().then(() => {
            this._addMultiple(toAdd);
            this._deleteMultiple(toRemove);
            return this.onContentsUpdated();
        });
    }
    getDefaultGraph() {
        return models_1.Graph.getOrCreate(this.namedNode.uri);
    }
    add(quad) {
        return this.init().then(() => {
            this.contents.add(quad);
            this.onContentsUpdated();
            return Promise.resolve(true);
        });
    }
    addMultiple(quads) {
        return this.init().then(() => {
            this._addMultiple(quads);
            this.onContentsUpdated();
            return Promise.resolve(true);
        });
    }
    _addMultiple(quads) {
        this.contents = this.contents.concat(quads);
    }
    delete(quad) {
        return this.init().then(() => {
            this.contents.delete(quad);
            this.onContentsUpdated();
            return true;
        });
    }
    deleteMultiple(quads) {
        return this.init().then(() => {
            this._deleteMultiple(quads);
            this.onContentsUpdated();
            return true;
        });
    }
    _deleteMultiple(quads) {
        quads.forEach((quad) => this.contents.delete(quad));
    }
    clearProperties(subjectToPredicates) {
        return this.init().then(() => {
            let toDelete = new QuadSet_1.QuadSet();
            this.contents.forEach((q) => {
                if (subjectToPredicates.has(q.subject) && subjectToPredicates.get(q.subject).has(q.predicate)) {
                    toDelete.add(q);
                }
            });
            if (toDelete.size > 0) {
                return this.deleteMultiple(toDelete);
            }
            return false;
        });
    }
    setURI(node) {
        // node.uri = newURI;
        return Promise.resolve(true);
    }
    onContentsUpdated() {
        //by default in memory store does nothing here. But extending classes could choose to sync to a more permanent form of storage
        return Promise.resolve(false);
    }
    removeNodes(nodes) {
        //when storage calls removeNodes, all quads have already been removed locally
        //and an in memory store always holds all data in memory,
        //so there is nothing to do here
        return Promise.resolve(true);
    }
    loadShape(shapeInstance, request) {
        return this.init().then(() => {
            return this.getRequestQuads(shapeInstance, request);
            //for testing: add timer
            // return new Promise((resolve, reject) => {
            //   setTimeout(() => {
            //get quads for each (nested) shape / property shape
            // let quads = this.getRequestQuads(shapeInstance, request);
            // return resolve(quads);
            // }, 1500);
            // });
        });
    }
    loadShapes(shapeInstances, request) {
        return this.init().then(() => {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    //get quads for each (nested) shape / property shape
                    //TODO: update getRequestQuads to work with shape set
                    // possibly even merge definitions of loadShape and loadShapes? is it select? query?
                    // let quads = this.getRequestQuads(shapeInstances, request);
                    // return Promise.resolve(quads);
                    // return resolve(quads);
                    return resolve([]);
                }, 1500);
            });
        });
    }
    getRequestQuads(source, request, quads = new QuadArray_1.QuadArray()) {
        // let {shape, properties}: {shape: typeof Shape; properties?: (PropertyShape | BoundPropertyShapes)[]} = request;
        request.forEach((propertyRequest) => {
            let subRequest;
            let propertyShape;
            let propertyShapeSource;
            //if an entry is an array, then it consists of the property shape + a sub request
            if (Array.isArray(propertyRequest)) {
                [propertyShape, subRequest] = propertyRequest;
            }
            else if (propertyRequest instanceof SHACL_1.PropertyShape) {
                propertyShape = propertyRequest;
            }
            if (propertyShape) {
                if (source instanceof QuadSet_1.QuadSet) {
                    propertyShapeSource = source.getObjects().getQuads(propertyShape.path);
                }
                else if (source instanceof Shape_1.Shape) {
                    propertyShapeSource = source.getQuads(propertyShape.path);
                }
                propertyShapeSource.forEach((q) => quads.push(q));
            }
            if (subRequest) {
                this.getRequestQuads(propertyShapeSource, subRequest, quads);
            }
        });
        return quads;
    }
};
InMemoryStore.targetClass = lincd_storage_1.lincdStorage.InMemoryStore;
InMemoryStore = __decorate([
    package_1.linkedShape
], InMemoryStore);
exports.InMemoryStore = InMemoryStore;
//# sourceMappingURL=InMemoryStore.js.map